module.exports = __webpack_public_path__ + "static/media/lidcore-detection-3.0439a131.jpg";